import React from 'react';
import AppRoutes from './Routes.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { StoreProvider } from './Context/context.jsx';
// import NetworkStatusOverlay from './components/Common/NetworkStatusOverlay.jsx';

import { SubscriptionRenewalProvider } from './context/SubscriptionRenewalContext.jsx';
import RenewSubscriptionModal from './components/Subscription/RenewSubscriptionModal.jsx';

function App() {
  return (
    <StoreProvider>
      <SubscriptionRenewalProvider>
        <AppRoutes />
        <ToastContainer position="top-right" autoClose={3000} />
        {/* <NetworkStatusOverlay /> */}
        <RenewSubscriptionModal />
      </SubscriptionRenewalProvider>
    </StoreProvider>
  );
}

export default App;
